import React from 'react';
import { Lightbulb, ChevronRight } from 'lucide-react';
import DraftLibrary from './DraftLibrary';

/**
 * DraftLibraryWithFindIdeas
 *
 * Combines the "Find Ideas" recommendation block with the Draft Library
 * Replaces the old Essay Workspace tab
 */
export default function DraftLibraryWithFindIdeas({
  essays = [],
  onSelectEssay,
  onCreateNew,
  onDeleteEssay,
  colleges = [],
  onNavigateToFindIdeas
}) {
  return (
    <div className="space-y-6">
      {/* Find Ideas Block 
      <div className="bg-white border-l-4 border-l-gold-500 border border-slate-900 rounded-xl overflow-hidden shadow-sm">
        <div className="p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 bg-gold-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <Lightbulb className="w-5 h-5 text-gold-600" />
              </div>
              <div className="flex-1">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-1">
                  <h2 className="text-slate-900 font-bold text-lg">
                    Find Ideas
                  </h2>
                  <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-gold-400 rounded-lg w-fit">
                    <svg className="w-3.5 h-3.5 text-slate-900" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <span className="text-slate-900 text-xs font-bold uppercase tracking-wide">
                      Start Here
                    </span>
                  </div>
                </div>
                <p className="text-stone-600 text-sm mb-1">
                  Best starting point for most students
                </p>
                <p className="text-slate-700 text-sm leading-relaxed hidden md:block">
                  Not sure what to write about? Explore prompts and discover compelling topics through AI-powered conversations. Your assessment provides the foundation for generating authentic ideas.
                </p>
              </div>
            </div>
          </div>

          <button
            onClick={onNavigateToFindIdeas}
            className="w-full md:w-auto mt-4 bg-slate-900 text-white px-6 py-3 rounded-lg font-medium text-sm flex items-center justify-center gap-2 hover:bg-slate-800 transition-colors"
          >
            Start Exploring Ideas
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
      */}

      {/* Draft Library */}
      <DraftLibrary
        essays={essays} 
        onSelectEssay={onSelectEssay}
        onCreateNew={onCreateNew}
        onDeleteEssay={onDeleteEssay}
        colleges={colleges}
      />
    </div>
  );
}
